export const NONE_OPTION_KEY = 'NONE';

export default NONE_OPTION_KEY;
